/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Page_Number_HintInputs */

const en_reading_class_page_number_hint = /** @type {(inputs: Reading_Class_Page_Number_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The number printed on each page`)
};

const es_reading_class_page_number_hint = /** @type {(inputs: Reading_Class_Page_Number_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El número impreso en cada página`)
};

/**
* | output |
* | --- |
* | "The number printed on each page" |
*
* @param {Reading_Class_Page_Number_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_page_number_hint = /** @type {((inputs?: Reading_Class_Page_Number_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Page_Number_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_page_number_hint(inputs)
	return en_reading_class_page_number_hint(inputs)
});